import { render, staticRenderFns } from "./jitsiMeet.vue?vue&type=template&id=1a18e83e&"
import script from "./jitsiMeet.vue?vue&type=script&lang=js&"
export * from "./jitsiMeet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports